import localforage from 'localforage';

export async function loadCache<T>(key: string): Promise<T[]> {
  try {
    const parsed = await localforage.getItem<{ [key: string]: T[] }>(`${key}`);
    if (!parsed) return [];
    if (Array.isArray(parsed[key])) {
      return parsed[key];
    }
  } catch (e) {
    console.error(`[cacheUtils] Failed to load or parse cached ${key}:`, e);
  }
  return [];
}

export async function saveCacheArray<T>(key: string, arr: T[]): Promise<void> {
  try {
    await localforage.setItem(`${key}`, { [key]: arr });
  } catch (e) {
    console.error(`[cacheUtils] Failed to save cached ${key}:`, e);
  }
}

export async function fetchWithTimeoutAndCache<T>(
  fetchFn: () => Promise<T>,
  cacheFn: () => Promise<T>,
  timeoutMs = 5000
): Promise<{ data: T; fromCache: boolean }> {
  let timeoutHit = false;
  let timeoutId: ReturnType<typeof setTimeout> | undefined = undefined;

  const timeoutPromise = new Promise<T>((resolve) => {
    timeoutId = setTimeout(() => {
      timeoutHit = true;
      resolve(undefined as unknown as T);
    }, timeoutMs);
  });

  const fetchPromise = fetchFn();

  try {
    const result = await Promise.race([fetchPromise, timeoutPromise]);
    clearTimeout(timeoutId);

    if (timeoutHit || result === undefined) {
      const cached = await cacheFn();
      return { data: cached, fromCache: true };
    }

    return { data: result, fromCache: false };
  } catch (err) {
    clearTimeout(timeoutId);
    console.log('Fetch error:', err);
    const cached = await cacheFn();
    return { data: cached, fromCache: true };
  }
}
